<template>
  <div class="score-wrap">
    <div class="score">
      <div class="score-content">
        <span>{{today}}</span>
      </div>
    </div>
    <div class="score">
      <div class="score-content">
        <span>{{lastWeek}}</span>
      </div>

    </div>
    <div class="score">
      <div class="score-content">
        <span>{{yesterday}}</span>
      </div>

    </div>
    <div class="score">
      <div class="score-content">
        <span>{{avg}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {sprintf} from 'sprintf-js'
export default {
  name: "JzzDashTapinGoal",
  props: {
    userDataIntegrityData: {
      type: Object,
      default: {}
    }
  },

  computed: {
    today() {
      return sprintf(this.$t('ProductInfo.consumption_today'),this.userDataIntegrityData.nowSeconds,this.userDataIntegrityData.nowNumber)
    },
    lastWeek() {
      return sprintf(this.$t('ProductInfo.average_consumption_last_week'),this.userDataIntegrityData.weekSeconds,this.userDataIntegrityData.weekNumber)
    },
    yesterday() {
      return sprintf(this.$t('ProductInfo.consumption_yesterday'),this.userDataIntegrityData.sumSecond,this.userDataIntegrityData.sumNumber)
    },
    avg() {
      return sprintf(this.$t('ProductInfo.max_pod_usage'),this.userDataIntegrityData.maxSeconds)
    }
  }
}
</script>

<style scoped lang="less">
.score-wrap {
  margin-top:10px;
  background: #222222;
  font-size:14px;
  padding:12px;
  & >  * + *  {
    margin-top:10px;
  }
}
</style>
